import { Divider, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import CallIcon from '@material-ui/icons/Call'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'

import { persianRegex } from '../../../../helpers/regex'
import { getTranslate } from '../../../../localization'
import { BookerInfo } from '../../../../types/bookingDetails'
import { useStyles } from './styles/index.styles'

type Props = { bookerInfo: BookerInfo | undefined; adminEditMode: boolean }
const BookerDetails = ({ bookerInfo }: Props) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isPersianBooker = persianRegex.test(
    bookerInfo?.firstName || bookerInfo?.lastName || ''
  )

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography className={classes.sectionTitle}>
          {getTranslate('The Booker Details')}
        </Typography>
      </div>
      <Divider />
      <div className={classes.content}>
        <div className={classes.personCard}>
          <div className={classes.iconBox}>
            <div className={classes.nameContainer}>
              <AccountCircleIcon className={classes.profileIcon} />
              <Typography
                variant="h5"
                className={classes.blackText}
                style={
                  isPersianBooker ? { fontFamily: 'IranSans' } : undefined
                }>
                {bookerInfo?.firstName + ' ' + bookerInfo?.lastName}
              </Typography>
            </div>
          </div>
          <div className={classes.detailsBox}>
            <div className={classes.row}>
              {isMobile ? (
                <PersonOutlineIcon className={classes.formIcon} />
              ) : (
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  className={classes.blackText}>
                  {`${getTranslate('ID Number')}: `} &nbsp;
                </Typography>
              )}
              <Typography
                variant={isMobile ? 'h6' : 'h5'}
                className={classes.blackText}>
                {bookerInfo?.idNumber}
              </Typography>
            </div>
            <div className={classes.row}>
              {isMobile ? (
                <CallIcon className={classes.formIcon} />
              ) : (
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  className={classes.blackText}>
                  {`${getTranslate('Mobile')}: `} &nbsp;
                </Typography>
              )}
              <Typography
                variant={isMobile ? 'h6' : 'h5'}
                className={classes.blackText}>
                {bookerInfo?.telephone}
              </Typography>
            </div>
            <div className={classes.row}>
              {isMobile ? (
                <MailOutlineIcon className={classes.formIcon} />
              ) : (
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  className={classes.blackText}>
                  {`${getTranslate('Email')}: `} &nbsp;
                </Typography>
              )}
              <Typography
                variant={isMobile ? 'h6' : 'h5'}
                className={classes.blackText}>
                {bookerInfo?.email}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BookerDetails
